<script>
  import { createEventDispatcher } from 'svelte';
  import { cart } from './storage.js';
  import { updateItem, removeItem, handleResponse, showErrors } from './requests.js';

  export let item;
  let thumbnail = item.image ? `${item.image}/200/200` : '/img/thumbnail.svg';

  $: quantity = Number(item.quantity)
  
  const dispatch = createEventDispatcher();
  const mediaQuery = window.matchMedia('(max-width: 767px)');
  const handleMediaChange = event => isMobile = event.matches;

  let isMobile = mediaQuery.matches;

  mediaQuery.addEventListener('change', handleMediaChange);

  const plus = () => {
    updateItem($cart.id, item.id, {token: $cart.token, quantity: quantity + 1})
    .then(handleResponse)
    .then(body => dispatch('refresh'))
    .catch(showErrors)
  }

  const minus = () => {
    updateItem($cart.id, item.id, {token: $cart.token, quantity: quantity - 1})
    .then(handleResponse)
    .then(body => dispatch('refresh'))
    .catch(showErrors)
  }

  const remove = () => {
    removeItem($cart.id, item.id, $cart.token)
    .then(handleResponse)
    .then(body => dispatch('refresh'))
    .catch(showErrors)
  }

</script>

<div class="IN1_cart__item">
  <div class="IN1_cart__item-image">
    <img src="{thumbnail}" alt="Zdjęcie produktu">
  </div>

  <div class="IN1_cart__item-name">
    {item.name}
  </div>
  
  <div class="IN1_cart__item-quantity">
    <div class="quantity">
      <button
        on:click={item.quantity == 1 ? remove : minus}
        class="quantity__manipulate" 
        class:disabled={item.quantity == 1 && !isMobile}
      >-</button>
      <div class="quantity__value">{ parseFloat(item.quantity).toFixed() } szt.</div>
      <button class="quantity__manipulate" on:click={plus}>+</button>
    </div>

    <span class="IN1_cart__item-price-single">{item.price_with_currency} / szt.</span>
  </div>

  <div class="IN1_cart__item-price">
    <div class="IN1_cart__item-price-total">{item.total_price_with_currency}</div>
  </div>

  <div class="IN1_cart__item-remove">
    <a class="item_remove" on:click={remove}>usuń</a>
  </div>
</div>


<style>
  .IN1_cart__item {
    border-bottom: 1px solid #e0e0e0;
    display: grid;
    grid-template-areas:
      "image name price"
      "image quantity remove";
    grid-template-columns: 120px auto max-content;
    grid-template-rows: max-content auto;
    width: 100%;
    grid-column-gap: 30px;
    grid-row-gap: 15px;
    padding: 20px 0;
  }

  .IN1_cart__item:first-of-type {
    padding-top: 0;
  }

  .IN1_cart__item-image {
    grid-area: image;
  }

  .IN1_cart__item-image img {
    max-width: 100%;
    display: block;
  }

  .IN1_cart__item-name {
    grid-area: name;
    align-self: end;
    font-weight: bolder;
    font-size: 1.2em;
  }

  .IN1_cart__item-quantity {
    grid-area: quantity;
  }

  .IN1_cart__item-price {
    grid-area: price;
    align-self: end;
    font-weight: 600;
    font-size: 1.2em;
    text-align: right;
  }

  .IN1_cart__item-remove {
    grid-area: remove;
    align-self: end;
    text-align: right;
  }

  .quantity {
    display: inline-grid;
    grid-template-columns: 30px minmax(60px, auto) 30px;
    border: 1px solid #cccccc;
    border-radius: 3px;
    align-items: center;
    font-size: 0.9em;
  }

  .quantity__value {
    border-left: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    padding: 2px 5px;
    text-align: center;
  }

  .quantity__manipulate {
    text-decoration: none;
    transition: background 0.2s ease-in-out;
    font-weight: bold;
    padding: 2px 5px;
    text-align: center;
    border: 0;
    height: 100%;
    color: #5D6AC5;
    cursor: pointer;
  }

  .quantity__manipulate:not(.disabled):hover {
    background-color: #cccccc;
  }

  .quantity__manipulate.disabled {
    color: #cccccc;
    cursor: default;
    pointer-events: none;
  }

  .item_remove {
    font-size: 0.8em;
    text-decoration: none;
    opacity: 0.8;
    transition: opacity 0.2s ease-in-out;
  }

  .item_remove:hover {
    opacity: 1;
  }

  .IN1_cart__item-price-single {
    font-size: 0.9em;
    margin-left: 10px;
  }

  @media (max-width: 767px) {
    .IN1_cart__item {
      grid-template-columns: 70px auto auto;
      grid-template-areas:
        "image name name"
        "image quantity price";
      grid-column-gap: 15px;
      grid-row-gap: 10px;
      border-bottom: 0;
    }

    .IN1_cart__item-name {
      font-size: 1em;
      line-height: 1.1em;
      font-weight: 400;
    }

    .IN1_cart__item-price {
      line-height: 1.1em;
      font-size: 1em;
      font-weight: 400;
      align-self: center;
    }

    .IN1_cart__item-quantity {
      align-self: center;
    }

    .IN1_cart__item-price-total {
      display: inline;
    }

    .IN1_cart__item-price-single {
      display: none;
    }

    .IN1_cart__item-remove {
      display: none;
    }
  }
</style>
